// utils
import { sendYaMetrikaEvent } from "../analytics";

// constants
import DOWNLOAD_MONETIZED_GOALS from "../../../constants/monetized-goals";

function handleBannerButtonDownloading() {
  const downloadButtons = document.querySelectorAll(".banner-button");
  Array.from(downloadButtons).forEach((elem) => {
    elem.addEventListener("click", async () => {
      const promoBrowserType = elem.getAttribute("data-uid")?.split("-")[0];
      sendYaMetrikaEvent(DOWNLOAD_MONETIZED_GOALS.bannerButton[promoBrowserType]);
      sendYaMetrikaEvent("download-not-yab");
    });
  });
}

export default handleBannerButtonDownloading;